// Shrinking as the app moves onto gentelella. Collapse, pagination, dropdown
// and the loading directive went with the table rebuild; date picker and
// option-group with the form controls; notifications with the toast swap.
//
// Everything left is here for the PUBLIC site — the admin uses none of it:
//   ElInput            components/modal/service.vue
//   ElSelect/ElOption  components/product-comparison.vue
//   ElSkeleton(Item)   pages/shop/detail.vue, pages/shop/grid.vue
//   ElBreadcrumb(Item) pages/shop.vue
//   ElDialog           components/detail-view/gallery.vue (image lightbox)
//
// These are all bare chrome with no visible Element Plus identity, so they sit
// fine alongside gentelella and are not worth the churn of replacing.
import {
  ElSelect,
  ElOption,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElSkeleton,
  ElSkeletonItem,
  ElDialog,
  ElInput,
} from 'element-plus'
import { showToast } from 'gentelella/v4/toast'

import 'element-plus/es/components/select/style/css'
import 'element-plus/es/components/option/style/css'
import 'element-plus/es/components/breadcrumb/style/css'
import 'element-plus/es/components/breadcrumb-item/style/css'
import 'element-plus/es/components/skeleton/style/css'
import 'element-plus/es/components/skeleton-item/style/css'
import 'element-plus/es/components/dialog/style/css'
import 'element-plus/es/components/overlay/style/css'
import 'element-plus/es/components/input/style/css'

// gentelella styles success/error/warning; anything else is the neutral toast.
// It carries no title — the colour band does that job — so the TITLES map the
// Element Plus notifications used is gone.
const VARIANTS = {
  success: 'success',
  error: 'error',
  warning: 'warning',
}

export default {
  install(app) {
    app.component('ElSelect', ElSelect)
    app.component('ElOption', ElOption)
    app.component('ElBreadcrumb', ElBreadcrumb)
    app.component('ElBreadcrumbItem', ElBreadcrumbItem)
    app.component('ElSkeleton', ElSkeleton)
    app.component('ElSkeletonItem', ElSkeletonItem)
    app.component('ElDialog', ElDialog)
    app.component('ElInput', ElInput)

    // Callers sometimes hand over an error payload rather than a string, and
    // showToast writes straight to textContent.
    const notify = (msg, type) =>
      showToast(typeof msg === 'string' ? msg : String(msg ?? ''), {
        variant: VARIANTS[type] || 'default',
        duration: 3000,
      })

    app.config.globalProperties.$message = (msg) => notify(msg, 'info')
    app.config.globalProperties.$success = (msg) => notify(msg, 'success')
    app.config.globalProperties.$warning = (msg) => notify(msg, 'warning')
    app.config.globalProperties.$error = (msg) => notify(msg, 'error')
    app.config.globalProperties.$info = (msg) => notify(msg, 'info')
  },
}
